import React, { useContext } from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import PropTypes from 'prop-types';
import { H5 } from '../text';
import LayoutContext from '../../contexts/Layout';

const CtaContainer = ({ contentItems, followContentLink = async () => {}, nodeTypeAlias = 'CtaContainer', references }) => {
    const { layout } = useContext(LayoutContext);

    return (
        <View
            style={{ marginBottom: layout.styleGuide.componentSeparator, marginHorizontal: layout.styleGuide.spacer1 + layout.styleGuide.indent }}
            dataSet={{
                umbracoComponentName: nodeTypeAlias,
                spacerBottom: `StyleGuide.ComponentSeparator(${layout.styleGuide.componentSeparator})`,
                spacerLeft: `StyleGuide.Spacer1 + StyleGuide.Indent(${layout.styleGuide.spacer1 + layout.styleGuide.indent})`,
                spacerRight: `StyleGuide.Spacer1 + StyleGuide.Indent(${layout.styleGuide.spacer1 + layout.styleGuide.indent})`
            }}
        >
            {Object.values(contentItems)?.map((item, idx) => {
                const id = item?.id;
                const text = item?.text;
                const externalUrl = item?.link?.externalUrl;
                const internalKey = item?.link?.internalKey;
                const isExternal = item?.link?.isExternal;

                return (
                    <View
                        dataSet={{ umbracoComponentName: item.nodeTypeAlias }}
                        key={id}
                        style={StyleSheet.flatten(Styles.item, {
                            backgroundColor: '#162b4a',
                            borderTopWidth: idx === 0 ? StyleSheet.hairlineWidth : null
                        })}
                    >
                        <Pressable
                            onPress={async () => {
                                if (externalUrl || internalKey) {
                                    await followContentLink(isExternal, internalKey, externalUrl, references);
                                }
                            }}
                            style={Styles.itemPressable}
                        >
                            <H5 style={{ color: '#fff' }} text={text} />
                        </Pressable>
                    </View>
                );
            })}
        </View>
    );
};

const Styles = StyleSheet.create({
    item: {
        alignContent: 'center',
        borderBottomWidth: StyleSheet.hairlineWidth,
        borderColor: '#fff',
        flexDirection: 'row',
        justifyContent: 'center',
        minHeight: 200
    },
    itemPressable: {
        alignItems: 'center',
        justifyContent: 'center'
    }
});

CtaContainer.propTypes = {
    contentItems: PropTypes.shape({
        id: PropTypes.number,
        text: PropTypes.string,
        link: PropTypes.shape({
            externalUrl: PropTypes.string,
            internalKey: PropTypes.string,
            isExternal: PropTypes.bool
        }),
        nodeTypeAlias: PropTypes.string
    }),
    nodeTypeAlias: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default CtaContainer;
